import { useCallback, useEffect, useState } from 'react';
import { featureFlagsAPI } from '../services/api';
import { DIRECTORY_V2_FLAG } from '../domain/filters/directoryColumns';

/**
 * Whether Filter Students should use the two-pane directory (default off).
 */
export function useDirectoryV2Enabled() {
  const [enabled, setEnabled] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const res = await featureFlagsAPI.status([DIRECTORY_V2_FLAG]);
      setEnabled(Boolean(res.data?.data?.enabled?.[DIRECTORY_V2_FLAG]));
    } catch {
      setEnabled(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return enabled;
}
